<template>
      <card>
        <list
          :filters="filters"
          :columns="columns"
          :modalCreate="modalCreate"
          :removeLink="removeLink"
          :cardLink="cardLink"
          :isUpdate="true"
          :isAdd="true"
          :itemLink="itemLink"
          :setLink="setLink"
          :syncLink="syncLink"
          :fields="fields"
          :searchDisable="false"
          @change="change"
          @changeFunction="changeFunction"
          v-model="val"
        />
      </card>
</template>
<script>
export default {
  name: "options",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
                filters: [
        {
          key: "category",
          title: "Фильтр по категории",
          titleKey:'title',
          field_key:"categories"
        },
        {
          key: "brand",
          title: "Фильтр по бренду",
          titleKey:'name',
          field_key:"brands"
        },
        {
          key: "name",
          title: "Фильтр по классу",
          titleKey:'title',
          field_key:"names"
        },
      ],
      val: [],
      modalCreate: "product",
      fields: [
      {
        col:' col-12 col-md-12',
        key: "product",
        label: "Группа",
        type: "select",
        selectKey: "display_name",
        modal: "product",
      },
      //       {
      //   col:' col-12 col-md-12',
      //   key: "categories",
      //   label: "Категории (тут оставим?)",
      //   type: "selects",
      //   selectKey: "title",
      //   modal: "category",
      // },
       {
        col:' col-12 col-md-6',
        key: "name",
        label: "Название модификации",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-6',
        key: "sku",
        label: "SKU",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-6',
        key: "barcode",
        label: "Штрихкод",
        type: "mask",
        mask: "#############",
        textType: "number",
      },
      {
        col:' col-12 col-md-6',
        key: "quantity",
        label: "Количество",
        type: "field",
        textType: "number",
      },
      {
        col:' col-12 col-md-6',
        key: "reward",
        label: "Награда",
        type: "field",
        textType: "number",
      },
      {
        col:' col-12 col-md-6',
        key: "price",
        label: "Цена",
        type: "field",
        textType: "number",
      },
      {
        col:' col-12 col-md-6',
        key: "price_retail",
        label: "Розничная цена",
        type: "field",
        textType: "number",
      },
      {
        col:' col-12 col-md-6',
        key: "price_old",
        label: "Старая цена",
        type: "field",
        textType: "number",
      },
      {
        col:' col-12 col-md-6',
        key: 'super_dealer_price',
        label: "Super dealer price",
        type: "field",
        textType: "number",
      },
      {
        col:' col-12 col-md-6',
        key: 'dealer_price',
        label: "Dealer price",
        type: "field",
        textType: "number",
      },
      {
        col:' col-12 col-md-6',
        key: 'wholesale_price',
        label: "Wholesale price",
        type: "field",
        textType: "number",
      },
      {
        col:' col-12 col-md-6',
        key: 'msrp_price',
        label: "Msrp price",
        type: "field",
        textType: "number",
      },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_option",
      itemLink: "warehouse/options",
      setLink: "warehouse/options",
      syncLink: "sync-products-1c", // sync-products-1c
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          sortBy:'id'
        },
        {
          key: "display_name",
          title: "Наименование",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "is_active",
          title: "Активность",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "sku",
          title: "SKU",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "product",
          title: "Группа",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          object: 'display_name',
        },
        {
          key: "price",
          title: "Цена",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
           sortBy:'price'
        },
        {
          key: "quantity",
          title: "Количество",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          sortBy:'quantity'
        },
        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
